import React, { ReactNode } from "react";
import {
  DataGrid,
  GridColDef,
  GridValueGetterParams,
  GridCellParams,
  GridRowParams,
  GridEventListener,
  GridEvents,
  MuiEvent,
  GridCallbackDetails,
} from "@mui/x-data-grid";
import { Game, Match } from "../../types/types";
import { Paper } from "@mui/material";

interface Props {
  rows: object[];
  columns: GridColDef[];
  height: number | string;
  onRowClick?: (params: GridRowParams) => ReactNode;
  onCellClick?: (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent>,
    details: GridCallbackDetails
  ) => void;
  rowHeight?: number;
  initialSortObject?: any;
}

function PlayerDataGrid({
  height,
  rows,
  columns,
  onRowClick,
  onCellClick,
  rowHeight = 38,
  initialSortObject = {},
}: Props) {
  return (
    <div style={{ height: height, display: "flex" }}>
      <Paper style={{ flexGrow: 1 }} elevation={5}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={30}
          onCellClick={onCellClick}
          onRowClick={onRowClick}
          rowHeight={rowHeight}
          initialState={initialSortObject}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "Mui-even" : "Mui-odd"
          }
        />
      </Paper>
    </div>
  );
}

export default PlayerDataGrid;
